<template>
    <div :class="['action-container', {'light': backgroundLight}]">
        <div v-if="$slots.heading" class="heading">
            <slot name="heading"></slot>
        </div>
        <div v-if="$slots.subheading" class="subheading">
            <slot name="subheading"></slot>
        </div>
        <div>
            <a class="button" v-if="!isAuth" :href="getUrl('/accounts/create-or-signin')" @click="register" title="Register / Sign in">Register / Login</a>
            <a class="button" v-if="isAuth" :href="getUrl('/accounts/fleet-upgrade')" @click="upgrade" title="Upgrade / Fleet">Upgrade / Fleet</a>
            <a v-if="moreInfoUrl && moreInfoUrl.length > 0" class="learn-more" :href="moreInfoUrl" title="Learn more about the feature">(More about the feature)</a>
        </div>
    </div>
</template>

<script>import script from './MarketingAction';
    export default script;</script>

<style lang="less" scoped>
    @import "./MarketingAction.less";
</style>
